/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CityDto } from '../../models/city-dto';

export interface CityGet$Params {
  CityId?: number;
  ProvinceId?: number;
  hasHospital?: boolean;
}

export function cityGet(http: HttpClient, rootUrl: string, params?: CityGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CityDto>>> {
  const rb = new RequestBuilder(rootUrl, cityGet.PATH, 'get');
  if (params) {
    rb.query('CityId', params.CityId, {});
    rb.query('ProvinceId', params.ProvinceId, {});
    rb.query('hasHospital', params.hasHospital, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CityDto>>;
    })
  );
}

cityGet.PATH = '/v1/City/Get';
